export default __webpack_public_path__ + "static/media/dress.154fc0f1.png";